module.exports = __webpack_public_path__ + "img/7a63eb3.svg";